<template>
  <div>
    <Header page="company"/>
    <div class="container">
      <div class="menu-vendor">
        <div class="d-flex align-items-center tabs-admin">
          <div :title="detailCompany.company_name" class="vendor-name">{{truncate(detailCompany.company_name,12,'...')}}</div>
          <b-tabs content-class="overflow-hidden">
            <!-- <b-tab :title="detailCompany.company_name" disabled>{{detailCompany.company_name}}</b-tab> -->
            <b-tab title="会社概要" @click="adminDetailCompany()">
            </b-tab>
            <b-tab  title="ダッシュボード" :active="tabIndex===2" @click="dashboardCompany()">
            </b-tab>
            <b-tab title="ファイル一覧" :active="tabIndex===3" @click="listFile">
            </b-tab>
            <b-tab title="社員一覧" :active="tabIndex===4" @click="listEmployee">
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Header from '../../share/Header'
export default {
  name: 'Tabs',
  components: {
    Header
  },
  data () {
    return {
    }
  },
  props: {
    tabIndex: Number
  },
  watch: {
  },
  methods: {
    listEmployee () {
      this.$router.push(`/admin/companies/${this.$route.params.id}/employees`)
    },
    listFile () {
      this.$router.push(`/admin/companies/${this.$route.params.id}/items/0`)
    },
    adminDetailCompany () {
      this.$router.push(`/admin/companies/${this.$route.params.id}/infor`)
    },
    dashboardCompany () {
      this.$router.push(`/admin/companies/${this.$route.params.id}/dashboard`)
    }
  },
  computed: {
    ...mapState({
      detailCompany: state => state.adminCompany.detailCompany
    })
  },
  mounted () {
    this.$store.dispatch('adminCompany/detailCompany', this.$route.params.id)
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/stylesheet/admin/vendor.scss";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Company/Tabs.vue